import { AxiosResponse } from 'axios'
import { RequestGENERIC, RequestREAD } from 'services/Instances'

export const CockpitServices = () => {
  const path = 'Cockpit'

  // Aba COCKPIT NGT 1
  const getServiceLevel = async (): Promise<
    AxiosResponse<INivelAtendimentoResponse>
  > => await RequestREAD.get(`${path}/NivelAtendimento`)

  const getCurrentRiskValue = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/ValorCalculoRisco`)

  const getRiskVsBlockingValue = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/VersusRiscoBloqueio`)

  const getRiskOpeningByTime = async (tipoCarteira): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/AberturaRiscoTempo`, {
      params: { tipoCarteira: tipoCarteira }
    })

  const getSlaWallet = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/SlaCarteira`)

  const getSlaPendency = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/SlaPendencia`)

  // Aba COCKPIT NGT 2
  const getTotalAnalysis = async (): Promise<
    AxiosResponse<ITotalAnalysisResponse>
  > => await RequestREAD.get(`${path}/TotalAnalise`)

  const getAnalysisVersusPendency = async (): Promise<
    AxiosResponse<IAnalysisVersusPendencyResponse>
  > => await RequestREAD.get(`${path}/VersusAnalisePendencia`)

  const getPendencyNotResolved = async (): Promise<
    AxiosResponse<IPendencyResponse>
  > => await RequestREAD.get(`${path}/PendenciaNaoResolvida`)

  const getPendencies = async (): Promise<AxiosResponse<IPendencyResponse>> =>
    await RequestREAD.get(`${path}/Pendencias`)

  const getResolvedPendency = async (): Promise<
    AxiosResponse<IPendencyResponse>
  > => await RequestREAD.get(`${path}/PendenciaResolvida`)

  const getDashboard = async (dataInicio, dataFim, idAnalista, competenciaInicio, competenciaFim): Promise<AxiosResponse<IDashboardAnalyst>> =>
    await RequestREAD.get(`${path}/DashboardAnalista`, {
      params: {
        dtInicio: dataInicio,
        dtFim: dataFim,
        idAnalista: idAnalista,
        competenciaInicio,
        competenciaFim
      }
    })

  const getByNome = async (
    nome: string,
    likeSearch: Boolean = false,
    dataInicio: Date,
    dataFim: Date
  ): Promise<AxiosResponse<IAnalystCockpit[]>> =>
    await RequestREAD.get(
      `${path}/GetByAnalystByName`, {
      params: {
        nome: nome,
        likeSearch: likeSearch,
        dtInicio: dataInicio,
        dtFim: dataFim,
      }
    }
    )

  // ROTAS AGREGADAS
  const aggregatedCockpitNgt1 = async (): Promise<
    AxiosResponse<IAggregatedCockpitNgt1>
  > => await RequestGENERIC.get('aggregatedCockpit_ngt1')

  const aggregatedCockpitNgt2 = async (): Promise<
    AxiosResponse<IAggregatedCockpitNgt2>
  > => await RequestGENERIC.get('aggregatedCockpit_ngt2')

  return {
    aggregatedCockpitNgt1,
    aggregatedCockpitNgt2,
    getAnalysisVersusPendency,
    getCurrentRiskValue,
    getDashboard,
    getPendencies,
    getPendencyNotResolved,
    getResolvedPendency,
    getRiskOpeningByTime,
    getRiskVsBlockingValue,
    getServiceLevel,
    getSlaPendency,
    getSlaWallet,
    getTotalAnalysis,
    getByNome
  }
}

export interface IAggregatedCockpitNgt1 {
  cockpit_nivelAtendimento: INivelAtendimentoResponse
  cockpit_slaCarteira: ISlaData
  cockpit_slaPendencia: ISlaData
  cockpit_valorCalculoRisco: ICalculoRiscoResponse
  cockpit_versusRiscoBloqueio: ICalculoRiscoResponse
}

export interface IAggregatedCockpitNgt2 {
  cockpit_pendencias: IPendencyResponse
  cockpit_totalAnalise: ITotalAnalysisResponse
  cockpit_versusAnalisePendencia: IAnalysisVersusPendencyResponse
}

export interface ISlaData {
  data: { diferencaDias: number; mesDiferencaDias: number }[]
  labels: string[]
}

interface IAnalystCockpit {
  nmUsuario: string,
  idUsuario: number
}

export interface ICalculoRiscoResponse {
  data: number[]
  labels: string[]
}

export interface ITotalAnalysisData {
  anoMes: number
  qtdItensAnalisados: number
  qtdAnalisado: number
  qtdPendente: number
  qtdBacklog: number
}

export interface INivelAtendimentoResponse {
  data: number[]
  labels: string[]
}

export interface ITotalAnalysisResponse {
  labels: string[]
  data: ITotalAnalysisData[]
}

export interface IAnalysisVersusPendencyResponse {
  labels: [string, string, string]
  data: [number, number, number]
}

export interface IPendencyData {
  vlQuantidade: number
  anoAnalise: number
}

export interface IPendencyResponseData {
  labels: string[]
  data: IPendencyData[]
}

export interface IPendencyResponse {
  pendenciaResolvida: IPendencyResponseData
  pendenciaNaoResolvida: IPendencyResponseData
}

export interface IDashboardAnalyst {
  informacaoSemanal: IInformacaoSeparadaSemanalmente[]
  informacaoValorRisco: {
    valorRiscoGeral: number
    valorRiscoEvitado: number
    valorRiscoNaoEvitado: number
    valorFRLiberadoGeral: number
    valorFRBloqueadoGeral: number
    valorFRLiberadoCompetencia: number
    valorFRBloqueadoCompetencia: number
  }
  qtdEfetivo: number
}

export interface IInformacaoSeparadaSemanalmente {
  numeroSemana: number
  informacaoSemanal?: IInformacaoSemanal[]
}

export interface IInformacaoSemanal {
  dia: number
  mes: number
  ano: number
  qtdCreAnalisado: number
  qtdPendenteAnalisado: number
}
